import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["drawer", "overlay", "openBtn", "closeBtn", "accordionTrigger"]

  connect() {
    this._onKeydown = (e) => { if (e.key === "Escape") this.close() }
    document.addEventListener("keydown", this._onKeydown)

    // Close the drawer when the viewport widens past the desktop breakpoint
    // (rotate/resize). The opener is d-lg-none (hidden >= 992px), so without
    // this the open drawer + body scroll-lock linger over the desktop layout.
    this._desktopQuery = window.matchMedia("(min-width: 992px)")
    this._onBreakpointChange = (e) => { if (e.matches) this.close() }
    this._desktopQuery.addEventListener("change", this._onBreakpointChange)
  }

  disconnect() {
    document.removeEventListener("keydown", this._onKeydown)
    this._desktopQuery.removeEventListener("change", this._onBreakpointChange)
  }

  open() {
    this.drawerTarget.classList.add("is-open")
    this.overlayTarget.classList.add("is-open")
    document.body.style.overflow = "hidden"
  }

  close() {
    this.drawerTarget.classList.remove("is-open")
    this.overlayTarget.classList.remove("is-open")
    document.body.style.overflow = ""
  }

  toggleAccordion(event) {
    const trigger = event.currentTarget
    const panel   = trigger.nextElementSibling
    const isOpen  = trigger.getAttribute("aria-expanded") === "true"
    trigger.setAttribute("aria-expanded", String(!isOpen))
    panel.classList.toggle("is-open", !isOpen)
  }
}
